import { AdminItemPath, AdminQuotationPath } from "@/common/enum/path";
import { AdminLayout } from "@/layout/AdminLayout";
import { ProductLayout } from "@/layout/ProductLayout";
import AdminDetailPage from "@/page/admin/AdminDetailPage";
import AdminListPage from "@/page/admin/AdminListPage";
import AdminMyProfilePage from "@/page/admin/AdminMyProfilePage";
import AdminNoticePage from "@/page/notification/AdminNoticePage";
import PartnerDetailPage from "@/page/partner/PartnerDetail/Page";
import PackageProductCreatePage from "@/page/product/package-product/PackageProductCreatePage";
import PackageProductDiscountsPage from "@/page/product/package-product/PackageProductDiscountsPage";
import PackageProductEditPage from "@/page/product/package-product/PackageProductEditPage";
import PackageProductPage from "@/page/product/package-product/PackageProductPage";
import SingleProductCreatePage from "@/page/product/single-product/SingleProductCreatePage";
import SingleProductDiscountsPage from "@/page/product/single-product/SingleProductDiscountsPage";
import SingleProductEditPage from "@/page/product/single-product/SingleProductEditPage";
import SingleProductPage from "@/page/product/single-product/SingleProductPage";
import { Navigate, Route, Routes } from "react-router-dom";
import { PartnerLayout } from "../layout/PartnerLayout";
import { QuotationLayout } from "../layout/QuotationLayout";
import { AdminHomePage } from "../page/AdminHomePage";
import AdminOrderDetailPage from "../page/order/AdminOrderDetail/page";
import { AdminOrderPage } from "../page/order/AdminOrderPage";
import PartnerListPage from "../page/partner/PartnerListPage";
import AdminQuoteDetailPage from "../page/quote/AdminQuoteDetailPage";
import { AdminQuotePage } from "../page/quote/AdminQuotePage";

export const AdminMainRouter = () => {
  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route path={"/profile"} element={<AdminListPage />} />
        <Route path={"/profile/my-profile"} element={<AdminMyProfilePage />} />
        <Route path={"/profile/detail/:id"} element={<AdminDetailPage />} />
        <Route path={"/notification"} element={<AdminNoticePage />} />
      </Route>

      <Route element={<PartnerLayout />}>
        <Route path={"/partner"} element={<PartnerListPage />} />
        <Route path={"/partner/detail/:id"} element={<PartnerDetailPage />} />
      </Route>

      <Route element={<QuotationLayout />}>
        <Route
          path={AdminQuotationPath.QUOTATION}
          element={<AdminQuotePage />}
        />
        <Route
          path={AdminQuotationPath.QUOTATION_DETAIL}
          element={<AdminQuoteDetailPage />}
        />
        <Route path={AdminQuotationPath.ORDER} element={<AdminOrderPage />} />
        <Route
          path={AdminQuotationPath.ORDER_DETAIL}
          element={<AdminOrderDetailPage />}
        />
      </Route>

      <Route element={<ProductLayout />}>
        <Route
          path={AdminItemPath.SINGLE_PRODUCT}
          element={<SingleProductPage />}
        />
        <Route
          path={AdminItemPath.SINGLE_PRODUCT_CREATE}
          element={<SingleProductCreatePage />}
        />
        <Route
          path={AdminItemPath.SINGLE_PRODUCT_DISCOUNTS}
          element={<SingleProductDiscountsPage />}
        />
        <Route
          path={`${AdminItemPath.SINGLE_PRODUCT}/:id${AdminItemPath.SINGLE_PRODUCT_EDIT}`}
          element={<SingleProductEditPage />}
        />
        <Route
          path={AdminItemPath.PACKAGE_PRODUCT}
          element={<PackageProductPage />}
        />
        <Route
          path={AdminItemPath.PACKAGE_PRODUCT_CREATE}
          element={<PackageProductCreatePage />}
        />
        <Route
          path={AdminItemPath.PACKAGE_PRODUCT_DISCOUNTS}
          element={<PackageProductDiscountsPage />}
        />
        <Route
          path={`${AdminItemPath.PACKAGE_PRODUCT}/:id${AdminItemPath.PACKAGE_PRODUCT_EDIT}`}
          element={<PackageProductEditPage />}
        />
      </Route>

      <Route path="/" element={<AdminHomePage />} />

      <Route path="*" element={<Navigate to={"/"} />} />
    </Routes>
  );
};
